/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import { maxLength, minLength, greaterThan, greaterThanEqualTo, lessThan, lessThanEqualTo, alphanumeric, numeric, email, creditCard, date, dateFormat, phone, postalCode, currency, pattern, string, boolean, array } from './validation';

const defaultValues = {
    'string': '',
    'number': 0,
    'date': null,
    'boolean': false,
    'array': []
};

class SchemaProperty {
    constructor(type) {
        this.type = type || 'string';
        this.mandatory = false;
        this.validators = [];
        this.defaultValue = undefined;
    }

    static prop(type) {
        return new SchemaProperty(type);
    }

    type(type) {
        this.type = type;
        return this;
    }

    defaultValue(value) {
        this.defaultValue = value;
        return this;
    }

    required(req = true) {
        this.mandatory = req;
        return this;
    }

    maxLength(max) {
        this.validators.push(maxLength(max));
        return this;
    }

    minLength(min) {
        this.validators.push(minLength(min));
        return this;
    }

    greaterThan(number) {
        this.validators.push(greaterThan(number));
        return this;
    }

    greaterThanEqualTo(number) {
        this.validators.push(greaterThanEqualTo(number));
        return this;
    }

    lessThan(number) {
        this.validators.push(lessThan(number));
        return this;
    }

    lessThanEqualTo(number) {
        this.validators.push(lessThanEqualTo(number));
        return this;
    }

    alphanumeric() {
        this.validators.push(alphanumeric);
        return this;
    }

    numeric() {
        this.validators.push(numeric);
        return this;
    }

    email() {
        this.validators.push(email);
        return this;
    }

    creditCard() {
        this.validators.push(creditCard);
        return this;
    }

    phone(patterns) {
        this.validators.push(phone(patterns));
        return this;
    }

    postalCode(patterns) {
        this.validators.push(postalCode(patterns));
        return this;
    }

    currency(patterns) {
        this.validators.push(currency(patterns));
        return this;
    }

    pattern(formats) {
        if (formats && formats.length > 0) {
            this.validators.push(pattern(formats));
        }
        return this;
    }

    string() {
        this.validators.push(string);
        return this;
    }

    boolean() {
        this.validators.push(boolean);
        return this;
    }

    array() {
        this.validators.push(array);
        return this;
    }
    
    date(formats) {
        if (!formats) {
            this.validators.push(date);
        } else {
            this.validators.push(dateFormat(formats));
        }
        return this;
    }

    custom(func) {
        this.type = 'custom';
        this.validators.push(func);
        return this;
    }

    validate(value) {
        if (!value) {
            return this.mandatory ? ['errors.required'] : [];
        }
        let type = typeof value;
        if (this.type !== 'custom' && this.type !== type) {
            if (type !== 'array' && Array.isArray(value)) {
                return ['errors.type'];
            }
        }
        const errors = [];
        for (let index = 0; index < this.validators.length; index++) {
            let validator = this.validators[index];
            let error = validator(value);
            if (error) {
                errors.push(error);
            }
        }
        return errors;
    }

    generate() {
        return this.defaultValue || defaultValues[this.type];
    }

}

export default SchemaProperty;
export const prop = SchemaProperty.prop;


export const generateSchema = (fields) => {
    const retVal = {};
    for (let key in fields) {
        let field = fields[key];
        retVal[key] = field.generate();
    }
    return retVal;
};